<script lang="ts">
  import Box from "@cohesionib/biblioteca/lib/Box";
  import HorizontalBarChart from "../shared/HorizontalStackedBarChart/HorizontalStackedBarChart.svelte";
  import type { ChartData } from "../shared/HorizontalStackedBarChart";

  import { mockTenantBreakdownData } from "./mockTenantBreakdownData";
  import TabPage from "@cohesionib/biblioteca/lib/TabPage/TabPage.svelte";
  import SubPage from "@cohesionib/biblioteca/lib/TabPage/SubPage.svelte";

  const tenantBreakdownChartData: ChartData = mockTenantBreakdownData.serviceRequests.map(
    (sr) => ({
      childBarKey: sr.type,
      data: sr.serviceRequests.map((d) => ({
        parentBarKey: d.tenantName,
        childBarValue: d.value,
      })),
    })
  );

  const childBarKeys = tenantBreakdownChartData[0].data.map(
    (d) => d.parentBarKey
  );
  const parentBarKeys = tenantBreakdownChartData.map((d) => d.childBarKey);

  const serviceBreakdownData: ChartData = childBarKeys.map((k: string) => ({
    childBarKey: k,
    data: parentBarKeys.map((pk) => ({
      parentBarKey: pk,
      childBarValue: tenantBreakdownChartData
        .filter((d) => d.childBarKey === pk)[0]
        .data.filter((cd) => cd.parentBarKey === k)[0].childBarValue,
    })),
  }));
</script>

<style>
  .tab-page {
    padding: 2em;
  }
  #graph-title {
    color: #4e4e4e;
    font-size: 1.5em;
    font-weight: 300;
    margin-top: -1.5em;
  }
  #graph-subtitle {
    font-weight: 200;
    color: #4e4e4e;
    font-size: 0.75em;
    padding-bottom: 1em;
  }
</style>

<Box title="Breakdown">
  <div class="tab-page">
    <TabPage justifyRight={true} showDropShadow={false}>
      <SubPage id="tenant-breakdown" title="By Tenant">
        <div id="graph-title">Tenant Breakdown</div>
        <div id="graph-subtitle">
          Breakdown of which tenants are submitting the most requests in a given
          period, and breakdown by type
        </div>
        <HorizontalBarChart
          data={tenantBreakdownChartData}
          includeTotalInTooltipTitle={true}
          titleTotalUnitLabel="requests" />
      </SubPage>
      <SubPage id="service-breakdown" title="By Type">
        <div id="graph-title">Service Request Breakdown</div>
        <div id="graph-subtitle">
          Breakdown of which services are requested the most, and breakdown by
          tenant
        </div>
        <HorizontalBarChart
          data={serviceBreakdownData}
          includeTotalInTooltipTitle={true}
          titleTotalUnitLabel="requests" />
      </SubPage>
    </TabPage>
  </div>
</Box>
